import { axios } from '@Root/API'

export const getByType = (role = 'student', value, type = 'name', limit = '100') => {
  return axios.get(`contacts/search/by-type`, { params: { type: role, sortBy: 'name:asc', search: `${type}:${value}`, limit } })
}
